// create tabs component using jQuery
export class Tabs {
  constructor(el) {
    this.$el = jQuery(el);
    this.$tabs = this.$el.find('.tab__item');
    this.$panels = this.$el.find('.tab__panel');
    this._bindEvents();
    this._init();
  }

  _bindEvents() {
    this.$tabs.on('click', this.handleTabClick.bind(this));
  }

  _init() {
    this.$tabs.first().click();
  }

  handleTabClick(e) {
    e.preventDefault();
    const $tab = jQuery(e.currentTarget);
    const tabId = $tab.attr('href');
    this.$tabs.removeClass('active');
    this.$panels.removeClass('active');
    $tab.addClass('active');
    console.log(tabId);
    this.$el.find(tabId).addClass('active');
  }
}
